exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.error-min-height[data-v-63ff5b85] {\n  min-height: 1.5em;\n}\n.copy-btn[data-v-63ff5b85] {\n  height: 1.5625rem;\n}\n.preview-btn[data-v-63ff5b85] {\n  padding: 0.25rem 0.65rem;\n  height: 1.55rem;\n  border: none;\n}\nbutton.btn.custom-widget[data-v-63ff5b85] {\n  padding: 0.25rem 0.5rem;\n  height: 1.45rem;\n  border: none;\n  box-shadow: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-63ff5b85","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/widget/widgetEditor.vue
// module id = 2518
// module chunks = 0